export default "__VITE_ASSET__D4iWE6nV__"